interface UserSearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  onAddUser: () => void;
  totalUsers: number;
  filteredUsers: number;
}

export default function UserSearchBar({
  searchTerm,
  onSearchChange,
  onAddUser,
  totalUsers,
  filteredUsers,
}: UserSearchBarProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-gray-400"></i>
              </div>
            </div>
            <input
              type="text"
              placeholder="이름, 전화번호로 검색..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent w-80"
            />
          </div>
          <button
            onClick={() => {
              console.log('새 회원 추가 버튼 클릭됨!');
              onAddUser();
            }}
            className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-add-line"></i>
            </div>
            <span>새 회원 추가</span>
          </button>
        </div>
        <div className="text-sm text-gray-500">
          전체 회원: {totalUsers}명 | 검색 결과: {filteredUsers}명
        </div>
      </div>
    </div>
  );
}
